import styled from "styled-components";
import { Button } from "../../AppStyle";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  height: 65vh;
  transition: background 0.3s ease-in-out;

  background-image: ${({ isDarkMode }) =>
    isDarkMode
      ? "url('/assets/dark/background-banner-dark.png')"
      : "url('/assets/light/background-banner-white.png')"};
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;

  .ContentWrapper {
    margin-top: 5%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .TitleMainHeading {
    font-size: 50px;
    line-height: 1;
    color: ${({ theme }) => theme.text};
    padding-bottom: 10px;
    font-family: "Roboto", "Montserrat", "Instruments-sans", sans-serif;
    font-weight: 600;
    word-spacing: 3px;
    max-width: 13em;
    text-align: center;
  }
  .DescriptionMainHeading {
    font-size: 20px;
    color: ${({ theme }) => theme.text};
    padding-bottom: 20px;
    font-family: "Roboto", "Montserrat", "Instruments-sans", sans-serif;
    word-spacing: 2px;
    max-width: 37em;
    text-align: center;
  }
  .DescriptionSubtext {
    color: ${({ theme }) => theme.subtext};
    font-weight: 700;
  }

  @media screen and (max-width: 768px) {
    height: auto;
    padding: 0px 20px 30px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    background-image: ${({ isDarkMode }) =>
      isDarkMode
        ? "url('/assets/dark/background-banner-mobile-dark.png')"
        : "url('/assets/light/background-banner-mobile-white.png')"};
    background-size: cover;
    background-position: center;
    .ContentWrapper {
      margin-top: 20px;
    }
    .TitleMainHeading {
      font-size: 30px;
      line-height: 1.3;
      max-width: 100%;
    }
    .DescriptionMainHeading {
      font-size: 15px;
      max-width: 100%;
    }
  }
`;

export const HeroButton = styled(Button)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 300px;
  height: 35px;
  color: black;
  border: 0px;
  border-radius: 15px;
  background: #dddf21;
  font-size: 15px;
  margin: 20px auto 20px;
  font-weight: 550;

  &:before {
    height: 500%;
  }

  &:hover:before {
    height: 0%;
  }

  &:hover {
    color: black;
    background-color: rgba(164, 166, 38, 0.85);
    transition-duration: 0.1s;
  }

  &:active {
    background-color: rgba(159, 159, 25, 0.83);
    color: black;
    transition-duration: 0.1s;
  }

  @media screen and (max-width: 1200px) {
    font-size: 17px;
    width: 100%;
    max-width: 400px;
    height: 3rem;
    margin: 20px auto 30px;
    border-radius: 30px;
  }
`;
